import { inject, provideAppInitializer } from '@angular/core';

import { LanguageStateService } from '../services/language-state.service';

export function provideLanguage() {
  return provideAppInitializer(() => inject(LanguageStateService).load());
}
